import { customBlogListReducer, CustomBlogListState } from "@hardware/Store/State/Blog/BlogListState";
import campaignFormReducer, { CampaignFormState } from "@hardware/Store/State/CampaignForm/CampaignFormState";
import { customCategoryPropsReducer, CustomCategoryPropsState } from "@hardware/Store/State/Category/CustomCategoryPropsState";
import { CreateAccountFormState, customCreateAccountReducer } from "@hardware/Store/State/CreateAccount/CreateAccountFormState";
import { customOrderFileUploadReducer, OrderFile } from "@hardware/Store/State/Order/CustomOrderFileUploadState";
import { customRFQFileUploadReducer, Files } from "@hardware/Store/State/RfqRequestQuote/CustomRFQFileUploadState";
import createTypedReducerWithImmer, { SurveyFormState } from "@hardware/Store/State/Survey/SurveyFormState";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";

(reducers as any).blogList = customBlogListReducer;
(reducers as any).rfqFileUpload = customRFQFileUploadReducer;
(reducers as any).surveyForm = createTypedReducerWithImmer;
(reducers as any).campaignForm = campaignFormReducer;
(reducers as any).categoryProps = customCategoryPropsReducer;
(reducers as any).orderFileUpload = customOrderFileUploadReducer;
(reducers as any).createAccountForm = customCreateAccountReducer;

export type CustomState = {
    name: string;
    blogList: CustomBlogListState;
    rfqFileUpload: Files;
    surveyForm: SurveyFormState;
    campaignForm: CampaignFormState;
    categoryProps: CustomCategoryPropsState;
    orderFileUpload: OrderFile;
    createAccountForm: CreateAccountFormState;
} & ApplicationState;

type Reducers = {
    customBlogListReducer: typeof customBlogListReducer;
    customRFQFileUploadReducer: typeof customRFQFileUploadReducer;
    customSurveyReducer: typeof createTypedReducerWithImmer;
    customCategoryPropsReducer: typeof customCategoryPropsReducer;
    customOrderFileUploadReducer: typeof customOrderFileUploadReducer;
    customCreateAccountReducer: typeof customCreateAccountReducer;
};

export type CustomActions = {
    [K in keyof Reducers]: Parameters<Reducers[K]>[1];
}[keyof Reducers] | AnyAction;
